import { textStyles, colors, loadingDark, loadingLight } from '../../shared/styles';

export const styles = {
  container: {
    marginBottom: 35
  },
  eventTitle: {
    marginBottom: 13,
    ...textStyles.sectionHead,
  },
  name: (isLink) => ({
    display: 'block',
    fontSize: 14,
    color: (isLink) ? colors.blue : colors.textColor,
  }),
  loadingTitle: {
    width: '50%',
    height: 12,
    marginBottom: 12,
    pointerEvents: 'none',
    ...loadingDark,
    transition: 'opacity 0.3s',
  },
  loadingDetail: {
    width: '100%',
    height: 15,
    pointerEvents: 'none',
    ...loadingLight,
    transition: 'opacity 0.3s',
  },
};



/** WEBPACK FOOTER **
 ** ./components/orgAndTimer/styles.js
 **/